import _classCallCheck from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { GraphQLError, isEnumType, isInputObjectType, isListType, isNonNullType, isObjectType, isScalarType } from "graphql";
import reduce from "lodash.reduce";
import { isNone } from "./is-none";

function ensureNullable(type) {
  return isNonNullType(type) ? type.ofType : type;
}

export var Parser = /*#__PURE__*/function () {
  function Parser(schema, functionsMap, validateEnums, nullFunctions) {
    _classCallCheck(this, Parser);

    this.schema = schema;
    this.functionsMap = functionsMap;
    this.validateEnums = validateEnums;
    this.nullFunctions = nullFunctions;
  }

  _createClass(Parser, [{
    key: "parseObjectWithSelections",
    value: function parseObjectWithSelections(data, type, selections) {
      var _this = this;

      var fieldMap = type.getFields();

      var fn = function fn(d, fieldNode) {
        return _this.treatSelection(d, fieldMap, fieldNode);
      };

      return reduce(selections, fn, data);
    }
  }, {
    key: "treatSelection",
    value: function treatSelection(data, fieldMap, fieldNode) {
      var name = fieldNode.name.value;
      var field = fieldMap[name];
      if (!field) return data;
      var key = fieldNode.alias ? fieldNode.alias.value : fieldNode.name.value;
      data[key] = this.treatValue(data[key], field.type, fieldNode);
      return data;
    }
  }, {
    key: "treatValue",
    value: function treatValue(value, givenType, fieldNode) {
      if (isNonNullType(givenType)) {
        return this.treatValueInternal(value, givenType, fieldNode);
      } else {
        return this.treatValueNullable(value, givenType, fieldNode);
      }
    }
  }, {
    key: "treatValueNullable",
    value: function treatValueNullable(value, givenType, fieldNode) {
      var wrappedValue = this.treatValueInternal(value, givenType, fieldNode);
      return this.nullFunctions.parseValue(wrappedValue);
    }
  }, {
    key: "treatValueInternal",
    value: function treatValueInternal(value, givenType, fieldNode) {
      var type = ensureNullable(givenType);
      if (isNone(value)) return value;

      if (isScalarType(type)) {
        return this.parseScalar(value, type);
      }

      if (isEnumType(type)) {
        this.validateEnum(value, type);
        return value;
      }

      if (isListType(type)) {
        return this.parseArray(value, type, fieldNode);
      }

      return this.parseNestedObject(value, type, fieldNode);
    }
  }, {
    key: "parseScalar",
    value: function parseScalar(value, type) {
      var fns = this.functionsMap[type.name] || type;
      return fns.parseValue(value);
    }
  }, {
    key: "validateEnum",
    value: function validateEnum(value, type) {
      if (!this.validateEnums || !value) return;
      var enumValues = type.getValues().map(function (v) {
        return v.value;
      });

      if (!enumValues.includes(value)) {
        throw new GraphQLError("enum \"".concat(type.name, "\" with invalid value"));
      }
    }
  }, {
    key: "parseArray",
    value: function parseArray(value, type, fieldNode) {
      var _this2 = this;

      return Array.isArray(value) ? value.map(function (v) {
        return _this2.treatValue(v, type.ofType, fieldNode);
      }) : value;
    }
  }, {
    key: "parseNestedObject",
    value: function parseNestedObject(value, givenType, fieldNode) {
      if (!value || !fieldNode || !fieldNode.selectionSet || !fieldNode.selectionSet.selections.length) {
        return value;
      }

      var type = this.getObjectTypeFrom(value, givenType);
      return type ? this.parseObjectWithSelections(value, type, fieldNode.selectionSet.selections) : value;
    }
  }, {
    key: "getObjectTypeFrom",
    value: function getObjectTypeFrom(value, type) {
      if (isInputObjectType(type) || isObjectType(type)) return type;
      if (!value.__typename) return null;
      var valueType = this.schema.getType(value.__typename);
      return isInputObjectType(valueType) || isObjectType(valueType) ? valueType : null;
    }
  }]);

  return Parser;
}();